import * as turf from "@turf/turf";
import { Feature } from "geojson";

export type FeatureWithDistance = Feature & { distance?: number };

export const addDistanceToFeatures = (
  startPoint: [number, number],
  features: Feature[],
): FeatureWithDistance[] => {
  const featuresWithDistance: FeatureWithDistance[] = features.map(
    (feature) => {
      if (!("coordinates" in feature.geometry)) return feature;

      const distance = turf.distance(
        startPoint,
        feature.geometry.coordinates as [number, number],
        { units: "kilometres" },
      );

      return { ...feature, distance };
    },
  );

  return featuresWithDistance;
};
